export default "__VITE_ASSET__YY_L5b1e__"